<div>
	<p>
		Pro maximální rychlost a stabilitu internetového připojení je nutné mít v rámci domácnosti
		zařízení připojeno kabelem.

		<b>
			Pokud máte v domácnosti router, přečtěte si
			<a href={resolve('podpora/router')}>více informací o routerech</a>
			.
		</b>
	</p>
	<p>
		<b>Jestliže máte domácí síť a router v pořádku</b>
		, a přesto pozorujete na své přípojce nějaké potíže, zkuste si
		<a href={resolve('podpora/rychlost')}>rychlost internetového připojení změřit</a>
		na zařízení připojením přes kabel (nikoli přes Wi-Fi routeru). Pokud naměřené hodnoty neodpovídají
		Vašemu tarifu, s výsledkem měření nás kontaktujte.
	</p>

	<H2>Co může způsobovat potíže s internetovým připojením?</H2>
	<ul class="list-inside list-disc">
		<li>Vadný router nebo vadný port v routeru,</li>
		<li>špatně nastavený router,</li>
		<li>
			špatně nastavená frekvence ve Vašem routeru (
			<a href={resolve('podpora/router/nefunguje')}>návod na nastavení zde</a>
			),
		</li>
		<li>vadný kabel či konektory na něm,</li>
		<li>
			vadná anténa pro příjem internetového signálu na Vaší střeše (je nutná návštěva našeho
			technika).
		</li>
	</ul>
	<p>
		<b
			>Pokud se Vám nedaří potíže vyřešit vlastními silami v rámci domácnosti, neváhejte nás
			kontaktovat pomocí formuláře níže.</b>
	</p>
</div>

<script lang="ts">
	import H2 from '#lib/components/ui/H2.svelte';
	import { resolve } from '$app/paths';
</script>
